import { gsap } from "gsap";

const navbar = () => {
  $(() => {
    $("body").on("click", ".menu-item .material-symbols-outlined", function () {
      $(this).next(".dropdown-menu").toggleClass("d-none");
    });

    // Header adattivo: "Menu" + hamburger diventano chiari sopra le sezioni marcate
    // data-header-theme="light" (sfondo scuro), scuri altrove. Rileva quale sezione
    // sta dietro la pill (in basso) alla sua posizione verticale.
    const header = document.querySelector(".site-header");
    const bar = header && header.querySelector(".site-header__bar");
    if (header && bar) {
      // Sezioni che pilotano il tema dell'header: attributo data-header-theme
      // (uso interno nei template) oppure classi header-light / header-dark
      // (usabili dall'editor via "Classi CSS aggiuntive").
      const themedSections = document.querySelectorAll("[data-header-theme], .header-light, .header-dark");
      let ticking = false;
      const applyTheme = () => {
        ticking = false;
        const r = bar.getBoundingClientRect();
        const y = r.top + r.height / 2;
        let theme = "dark";
        themedSections.forEach((sec) => {
          const b = sec.getBoundingClientRect();
          if (b.top <= y && b.bottom >= y) {
            theme =
              sec.dataset.headerTheme ||
              (sec.classList.contains("header-light") ? "light" : "dark");
          }
        });
        header.classList.toggle("site-header--light", theme === "light");
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(applyTheme);
        }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      applyTheme();
    }

    // Il nav flottante non deve coprire il footer: quando il footer sta per coprirlo
    // il nav sfuma via (fade), e rientra scrollando su. autoAlpha (come l'intro) per
    // non creare conflitti; agisce solo al cambio di stato (a inizio pagina non tocca
    // il nav, gestito dall'animazione d'ingresso).
    const footer = document.querySelector(".site-footer");
    if (header && footer) {
      const GAP = 24;
      let hidden = false;
      let dockTicking = false;

      const update = () => {
        dockTicking = false;
        const footerTop = footer.getBoundingClientRect().top;
        const navBottom = header.getBoundingClientRect().bottom; // fixed => innerHeight - offset
        const shouldHide = footerTop < navBottom + GAP;
        if (shouldHide && !hidden) {
          hidden = true;
          gsap.to(header, { autoAlpha: 0, duration: 0.4, ease: "power2.out" });
        } else if (!shouldHide && hidden) {
          hidden = false;
          gsap.to(header, { autoAlpha: 1, duration: 0.4, ease: "power2.out" });
        }
      };

      const onDockScroll = () => {
        if (!dockTicking) {
          dockTicking = true;
          requestAnimationFrame(update);
        }
      };

      window.addEventListener("scroll", onDockScroll, { passive: true });
      window.addEventListener("resize", onDockScroll);
      update();
    }

    const toggleButton = document.querySelector(".site-header__toggle");
    const panel = document.getElementById("navbarPanel");

    if (!toggleButton || !panel) return;

    const isOpen = () => panel.classList.contains("aperto");

    const setState = (open) => {
      toggleButton.classList.toggle("is-open", open);
      panel.classList.toggle("aperto", open);
      toggleButton.setAttribute("aria-expanded", String(open));
      panel.setAttribute("aria-hidden", String(!open));
    };

    toggleButton.addEventListener("click", () => setState(!isOpen()));

    document.addEventListener("click", (event) => {
      if (isOpen() && !event.target.closest(".site-header")) {
        setState(false);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && isOpen()) {
        setState(false);
        toggleButton.focus();
      }
    });
  });
};

export default navbar;
